<template>
  <div class="pills-overview-wrapper">
    <span :class="`pills-overview__${ firstStatus }`"></span>
    <span :class="`pills-overview__${ secondStatus }`"></span>
    <span :class="`pills-overview__${ thirdStatus }`"></span>
  </div>
</template>

<script>
  export default {
    name: 'BomValidationOverviewStatus',
    props: {
      firstStatus: {
        type: String,
        default: '',
        required: true
      },
      secondStatus: {
        type: String,
        default: '',
        required: true
      },
      thirdStatus: {
        type: String,
        default: '',
        required: true
      }
    }
  }

</script>

<style scoped lang="scss">
  .pills-overview-wrapper {
    display: flex;
    gap: 8px;
  }

  .pills-overview {
    &__green,
    &__red {
      display: inline-block;
      min-width: 8px;
      min-height: 8px;
      width: 8px;
      height: 8px;
      border-radius: 50%;
    }

    &__green {
      background: #b3cd63;
    }

    &__red {
      background: #e40045;
    }
  }
</style>
